import { graphql, useStaticQuery } from 'gatsby';
import { AudienceDataFragment } from '../types/graphqlTypes';

export const useAudienceData = (): AudienceDataFragment => {
  const { audienceData } = useStaticQuery(
    graphql`
      query GET_AUDIENCE_DATA {
        audienceData: kfhContentGlobalSettingsUmbracoType {
      ...AudienceData
    }
      }
    `
  );

  return audienceData as AudienceDataFragment;
};
